import React from 'react';
import PropTypes from 'prop-types';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { SanitizeHtml, Image } from '@bd/bdcore-utilities';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import PageIntroBanner from '../../components/PageIntroBanner';
import MenuAbout from '../../components/MenuAbout';
import { colors, typography } from '../../styles';

const styles = css`
  .LeadContent_wrapper {
    display: block;
    width: 100%;
    background-color: ${colors.color3};
    padding-top: 35px;
    padding-bottom: 35px;
    @media (min-width: 992px) {
      padding-top: 70px;
      padding-bottom: 70px;
    }
  }
  .PageContent_wrapper {
    padding-top: 35px;
    padding-bottom: 35px;
    @media (min-width: 992px) {
      padding-top: 70px;
      padding-bottom: 70px;
    }
  }
  .PageSection_wrapper {
    padding-top: 15px;
    padding-bottom: 15px;
    @media (min-width: 992px) {
      padding-top: 35px;
      padding-bottom: 35px;
    }
  }
  .PageTitle_wrapper {
    display: block;
    width: 100%;
    margin-bottom: 30px;
  }
  .PageTitle {
    font-weight: 600;
    font-size: 22px;
    color: ${colors.color2};
    margin-bottom: 10px;
    @media(min-width: 768px) {
      font-size: 26px;
      margin-bottom: 15px;

    }
    @media(min-width: 992px) {
      font-size: 32px;
    }
  }
  .LeadCopyWrapper {
    @media (min-width: 768px) {
      padding: 0 60px 0 0;
    }
  }
  .LeadCopy {
    font-weight: 300;
    font-size: 16px;
    color: ${colors.color1};
    letter-spacing: 0;
    line-height: 26px;
    margin: 0;
    @media (min-width: 992px) {
      font-size: 20px;
      line-height: 34px;
      letter-spacing: 0.4px;
    }
  }
  .PageImageWrapper {
    margin-top: 15px;
  }
  .PageImage {
    width: 100%;
  }
  .BodyContent_wrapper {
  }
  .BodyTitle {
    display: block;
    text-transform: none;
    font-weight: 500;
    font-size: 30px;
    color: ${colors.color2};
    letter-spacing: 0.25px;
    margin-bottom: 15px;
  }
  .BodyCopy p {
    font-size: 16px;
    line-height: 27px;
    @media (min-width: 768px) {
    font-size: 18px;
    color: #656565;
    letter-spacing: 0.3px;
    line-height: 32px;
    }
  }
  .bioSection {
    padding:40px 0;
  }
  .bio-wrapper {
    display:flex;
    flex-flow:row wrap;
    justify-content:center;
    .media {
      width:100%;
      display:flex;
      flex-flow:column wrap;
      justify-content:center;
      @media (min-width: 768px) {
        width:50%;
      }
      img {
        max-width:100%;
        height:auto;
      }
    }
    .content {
      width:100%;
      padding:30px 0;
      display:flex;
      flex-flow:column wrap;
      justify-content:center;
      @media (min-width: 768px) {
        width:50%;
        padding:30px;
      }
    }
  }
  .awardsSection {
    padding:40px 0;
  }
  .awards-wrapper {
    display:flex;
    flex-flow:row wrap;
    justify-content:center;
    .media {
      width:100%;
      display:flex;
      flex-flow:column wrap;
      justify-content:center;
      @media (min-width: 768px) {
        width:50%;
      }
      img {
        max-width:100%;
        height:auto;
      }
    }
    .content {
      width:100%;
      padding:30px 0;
      display:flex;
      flex-flow:column wrap;
      justify-content:center;
      @media (min-width: 768px) {
        width:50%;
        padding:30px;
      }
    }
  }
  .CardTitle {
    font:700 24px/1.2 ${typography.SansSerif};
  }
  .CardBody {
    margin-bottom:30px;
  }
  .btn {
    color:white;
    display:inline-block;

  }
`;

function AboutUs({ page }) {
  return (
    <PageWrapper className={styles}>
      <PageHelmet page={page} />
      <InsideHeader
        h1={`${page.meta.name}`}
        background={get(page, 'page_image.contentUrl')}
      />
      <MenuAbout />
      <PageIntroBanner
        heading={get(page, 'page_intro_banner[0].heading')}
        body={get(page, 'page_intro_banner[0].text')}
        image={get(page, 'page_intro_banner[0].image.contentUrl')}
      />
      <div className="PageContent_wrapper">
        <div className="container">
          <div className="BodyContent_wrapper">
            <h3 className="PageTitle">{get(page, 'body_title')}</h3>
            <div dangerouslySetInnerHTML={SanitizeHtml(get(page, 'body_copy'))} className="BodyCopy" />
          </div>
          {
            get(page, 'bio_section') &&
            <section className="bioSection">
              <h2 className="PageTitle">Team</h2>
              {
                page.bio_section.map(item => (
                  <div className="bio-wrapper">
                    <div className="media">
                      <Image
                        src={item.image.contentUrl}
                        alt={item.caption}
                      />
                    </div>
                    <div className="content">
                      <h3 className="CardTitle">{item.headline}</h3>
                      <div>{item.body_copy}</div>
                    </div>
                  </div>
                ))
              }
            </section>
          }
          {
            get(page, 'awards_section') &&
            <section className="awardsSection">
              <h2 className="PageTitle">Awards</h2>
              {
                page.awards_section.map(item => (
                  <div className="awards-wrapper">
                    <div className="media">
                      <Image
                        src={item.image.contentUrl}
                        alt={item.caption}
                      />
                    </div>
                    <div className="content">
                      <h3 className="CardTitle">{item.headline}</h3>
                      <div className="CardBody">{item.body_copy}</div>
                      {
                        get(item, 'link_label') &&
                        <a href={get(item, 'link_url')} className="btn" target={item.open_link_in_new_tab ? '_blank' : undefined}>{get(item, 'link_label')}</a>
                      }
                    </div>
                  </div>
                ))
              }
            </section>
          }
        </div>
      </div>
    </PageWrapper>
  );
}

AboutUs.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'about_us',
})(AboutUs);



// WEBPACK FOOTER //
// ./src/pages/AboutUs/index.js